export function formatWhatsappNumber(string) {
	return string.replace(/[\. ,:-]+/g, "")
}